
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgYoutubeBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 24,
  viewBox: "0 0 32 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M30.721 20.579c-.585 1.315-2.094 2.506-3.511 2.769-.145.027-3.608.652-11.201.652h-.02c-7.592 0-11.058-.625-11.202-.651-1.417-.264-2.927-1.455-3.513-2.771C1.222 20.461 0 17.647 0 12c0-5.647 1.222-8.462 1.274-8.579C1.86 2.105 3.37.915 4.787.652 4.931.625 8.397 0 15.989 0c7.613 0 11.076.625 11.22.651 1.418.264 2.927 1.454 3.513 2.769.052.118 1.277 2.933 1.277 8.58s-1.225 8.461-1.278 8.579ZM28.892 4.23c-.312-.701-1.29-1.471-2.048-1.612C26.812 2.612 23.385 2 16.009 2c-7.395 0-10.825.612-10.858.618-.758.141-1.735.911-2.048 1.616-.01.021-1.102 2.595-1.102 7.766 0 5.17 1.092 7.744 1.104 7.77.311.701 1.288 1.471 2.047 1.612.032.006 3.462.618 10.837.618h.02c7.376 0 10.803-.612 10.836-.618.758-.141 1.735-.911 2.048-1.616.01-.022 1.104-2.596 1.104-7.766s-1.094-7.745-1.105-7.77ZM13.54 17.846a.994.994 0 0 1-1.016.029 1 1 0 0 1-.517-.875V7a.999.999 0 0 1 1.526-.851l8.019 4.956a.999.999 0 0 1 .007 1.696l-8.019 5.045Zm.468-9.052v6.395l5.128-3.226-5.128-3.169Z",
  fill: "#000"
})));

      const __svgRaw = "<svg width=\"32\" height=\"24\" viewBox=\"0 0 32 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M30.721 20.579C30.136 21.894 28.627 23.085 27.21 23.348C27.065 23.375 23.602 24 16.009 24H15.989C8.397 24 4.931 23.375 4.787 23.349C3.37 23.085 1.86 21.894 1.274 20.578C1.222 20.461 0 17.647 0 12C0 6.353 1.222 3.538 1.274 3.421C1.86 2.105 3.37 0.915 4.787 0.652C4.931 0.625 8.397 0 15.989 0C23.602 0 27.065 0.625 27.209 0.651C28.627 0.915 30.136 2.105 30.722 3.42C30.774 3.538 31.999 6.353 31.999 12C31.999 17.647 30.774 20.461 30.721 20.579ZM28.892 4.23C28.58 3.529 27.602 2.759 26.844 2.618C26.812 2.612 23.385 2 16.009 2C8.614 2 5.184 2.612 5.151 2.618C4.393 2.759 3.416 3.529 3.103 4.234C3.093 4.255 2.001 6.829 2.001 12C2.001 17.17 3.093 19.744 3.105 19.77C3.416 20.471 4.393 21.241 5.152 21.382C5.184 21.388 8.614 22 15.989 22H16.009C23.385 22 26.812 21.388 26.845 21.382C27.603 21.241 28.58 20.471 28.893 19.766C28.903 19.744 29.997 17.17 29.997 12C29.997 6.83 28.903 4.255 28.892 4.23ZM13.54 17.846C13.378 17.949 13.192 18 13.007 18C12.841 18 12.675 17.959 12.524 17.875C12.205 17.699 12.007 17.364 12.007 17V7C12.007 6.637 12.203 6.303 12.52 6.127C12.837 5.95 13.226 5.958 13.533 6.149L21.552 11.105C21.845 11.286 22.025 11.606 22.026 11.951C22.027 12.296 21.851 12.618 21.559 12.801L13.54 17.846ZM14.008 8.794V15.189L19.136 11.963L14.008 8.794Z\" fill=\"black\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/youtube-black.892127c63c033344bcb7b8194d42eee1.svg"),
        {
          React: SvgYoutubeBlack,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      